import { MaintenanceWindowPreviewPatchManagementController } from '../controller/MaintenanceWindowPreviewPatchManagementController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class MaintenanceWindowPreviewPatchManagementWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MaintenanceWindowPreviewPatchManagementController,
    });
  }

  get maintenanceWindowId(): string {
    const value = this.getAttribute('data-maintenance-window-id');

    if (value === null) {
      return '';
    }

    return value;
  }

  set maintenanceWindowId(value: string) {
    this.setAttribute('data-maintenance-window-id', value);

    if (!this.started) {
      return;
    }

    // Re-render component when selected value changes
    this.propertiesSet = true;
  }
}
